// 管理画面ダッシュボード機能
document.addEventListener('DOMContentLoaded', function() {
  // ダッシュボードのTODOアラートクリックハンドラー
  const todoAlerts = document.querySelectorAll('.todo-alert');
  
  todoAlerts.forEach(function(alertBox) {
    alertBox.addEventListener('click', function(e) {
      // 直接のリンクがクリックされた場合以外はナビゲートする
      if (e.target.tagName !== 'A') {
        const link = this.querySelector('a');
        if (link) {
          window.location.href = link.href;
        }
      }
    });
  });
});
